<div class="card">
  <h3 class="font-semibold text-base mb-3">Attachments & Photos</h3>

  @if (errorMessage) {
    <p class="text-danger-base text-sm mb-2">{{errorMessage}}</p>
  }

  <div class="assets-grid">
    <div class="asset-block">
      <div class="asset-header">
        <div>
          <p class="label">Attachments</p>
          <p class="text-xs text-grey-600">Upload documents or files</p>
        </div>
        <label class="btn-inverse btn-compact btn-small upload-btn">
          <input type="file" class="hidden-input" (change)="onAttachmentSelected($event)">
          <i class="pi text-xs" [ngClass]="uploadingAttachment ? 'pi-spin pi-spinner' : 'pi-upload'"></i>
          <span class="ml-1 text-xs">{{uploadingAttachment ? 'Uploading...' : 'Upload'}}</span>
        </label>
      </div>
      @if (attachments.length === 0) {
        <p class="text-grey-500 text-sm">No attachments.</p>
      }
      @for (a of attachments; track a) {
        <div class="attachment-row">
          <div class="flex items-center gap-3">
            @if (isImageAttachment(a)) {
              <img [src]="attachmentSrc(a.GUID)" alt="Preview" class="attachment-thumb">
            }
            <p class="text-sm font-semibold">{{a.FileName}}</p>
          </div>
          @if (a.GUID) {
            <div class="flex gap-2">
              <button pButton class="btn-inverse btn-compact btn-xs" type="button" (click)="onDownload(a.GUID!)">
                <i class="pi pi-download"></i>
              </button>
              <button pButton class="btn-danger btn-compact btn-xs" type="button" (click)="onRemove(a.GUID!, $event)">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          }
        </div>
      }
    </div>

    <div class="asset-block">
      <div class="asset-header">
        <div>
          <p class="label">Photos</p>
          <p class="text-xs text-grey-600">Upload images for this action</p>
        </div>
        <label class="btn-inverse btn-compact btn-small upload-btn">
          <input type="file" accept="image/*" class="hidden-input" (change)="onPhotoSelected($event)">
          <i class="pi text-xs" [ngClass]="uploadingPhoto ? 'pi-spin pi-spinner' : 'pi-image'"></i>
          <span class="ml-1 text-xs">{{uploadingPhoto ? 'Uploading...' : 'Upload'}}</span>
        </label>
        <button pButton type="button" class="btn-primary btn-compact btn-small" (click)="showCamera ? closeCamera() : openCamera()">
          <i class="pi text-xs" [ngClass]="showCamera ? 'pi-times' : 'pi-camera'"></i>
          <span class="ml-1 text-xs">{{showCamera ? 'Close' : 'Photo'}}</span>
        </button>
      </div>
      @if (showCamera) {
        <div class="camera-block">
          <webcam [trigger]="triggerObservable" (imageCapture)="onCapture($event)" [width]="480" [height]="320"></webcam>
          <div class="camera-actions">
            <button pButton type="button" class="btn-primary btn-small" [disabled]="uploadingPhoto" (click)="takePicture()">
              <i class="pi" [ngClass]="uploadingPhoto ? 'pi-spin pi-spinner' : 'pi-camera'"></i>
              <span class="ml-1">{{uploadingPhoto ? 'Capturing...' : 'Capture'}}</span>
            </button>
          </div>
        </div>
      }
      @if (photos.length === 0) {
        <p class="text-grey-500 text-sm">No photos.</p>
      }
      @if (photos.length > 0) {
        <div class="photo-grid">
          @for (p of photos; track p) {
            <div class="photo-row">
              <img [src]="p" class="photo-thumb" />
              <div class="photo-actions">
                <button pButton type="button" class="btn-inverse btn-compact btn-xs" (click)="onDownloadPhoto(p)">
                  <i class="pi pi-download"></i>
                </button>
                <button pButton type="button" class="btn-danger btn-compact btn-xs" (click)="onRemovePhoto(p, $event)">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
